import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import {getElection} from '../../election/store/selectors';

interface IPropsDialog {
  open: boolean;
  onClose: () => void;
}

const HelpDialog: React.FC<IPropsDialog> = ({open, onClose}) => {
  const {t} = useTranslation();
  const election = useSelector(getElection);
  const helpHtmlText = election && election.help ? election.help : '';

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle id="simple-dialog-title">
        <Grid
          item={true}
          container={true}
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <span>{t('autenticacao.ajuda')}</span>
          <IconButton aria-label="close" onClick={handleClose}>
            <Close />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        {helpHtmlText && (
          <div dangerouslySetInnerHTML={{__html: helpHtmlText}} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default HelpDialog;



// WEBPACK FOOTER //
// ./src/features/auth/helpDialog/HelpDialog.tsx